import shopifyGenericDefaults from '../shopify-warehouse-generic/config.js';

const mobileScreenWidth = 999;

const { baseFields } = shopifyGenericDefaults.fitmentSearch;

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-warehouse-generic'],
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'VehicleWidgetDialog',
          'VerifyFitment',
          'SearchVehicleWidget',
          'FacetDialog',
          'FitmentTable',
        ].includes(w.name),
    ),
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm_vehicle-widget__home',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 900,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      fields: baseFields,
      visibleIf: () => window.innerWidth > mobileScreenWidth,
    },
    {
      name: 'SearchVehicleWidget_mobile',
      type: 'VehicleWidget',
      visibleIf: () => window.innerWidth <= mobileScreenWidth,
      columnBreakpoint: mobileScreenWidth,
      isAlwaysActive: true,
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/collapsibleVerifyFitment',
      isAlwaysColumnLayout: true,
      initCollapsed: true,
    },
    {
      name: 'DesktopFitmentTable',
      type: 'FitmentTable',
      location: '.product-block-list__item--description.wd-hidden-phone #cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'MobileFitmentTable',
      type: 'FitmentTable',
      location: '.product-block-list__item--description:not(.wd-hidden-phone) #cm-fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      initCollapsed: window.Convermax.config?.facetDialogInitCollapsed ?? true,
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
      globalVehicleDiscardEnabled: true,
      isAlwaysColumnLayout: true,
    },
  ],
};
